import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzCardModule } from 'ng-zorro-antd/card';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LibsModule } from '../../libs/libs.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { GenerateQrisComponent } from './generate-qris.component';
import { GeneratedQrisComponent } from './components/generated-qris/generated-qris.component';
import { ModalDownloadQrisComponent } from './components/modal-download-qris/modal-download-qris.component';
import { QRCodeModule } from "angularx-qrcode";
import { TableHistoryQrisComponent } from './components/table-history-qris/table-history-qris.component';
import { ModalInsufficientBalanceComponent } from './components/modal-insufficient-balance/modal-insufficient-balance.component';
import { ModalConfirmPaymentComponent } from './components/modal-confirm-payment/modal-confirm-payment.component';
import { GenerateQrisRoutingModule } from './generate-qris-routing.module';

@NgModule({
  declarations: [
    GenerateQrisComponent,
    GeneratedQrisComponent,
    ModalDownloadQrisComponent,
    TableHistoryQrisComponent,
    ModalInsufficientBalanceComponent,
    ModalConfirmPaymentComponent
  ],
  imports: [
    CommonModule,
    NzCardModule,
    AntDModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    LibsModule,
    NgxDaterangepickerMd,
    QRCodeModule,
    GenerateQrisRoutingModule
],
  exports: [
    GenerateQrisComponent,
    GeneratedQrisComponent,
    ModalDownloadQrisComponent,
    TableHistoryQrisComponent,
    ModalInsufficientBalanceComponent,
    ModalConfirmPaymentComponent
  ]
})
export class GenerateQrisModule { }
